// Import React and Component
import React, { Component } from "react";
import "bulma/css/bulma.css";
import "./App.css";
import FaucetInfo from "./FaucetInfo/FaucetInfo";
import FaucetRequest from "./FaucetRequest/FaucetRequest";
import config from "react-global-configuration";
import configuration from "./config";

config.set(configuration);

class App extends Component {
  render() {
    return (
      <div>
        <section className="header">
          <div className="container">
            <div className="inner-container">
              <img src="images/logo.svg" className="logo" />
              <h1 className="title">GoChain Testnet Faucet</h1>
            </div>
          </div>
        </section>
        <div className="container">
          <FaucetRequest />
        </div>
        <div className="container">
          <div className="section as-row">
            <div className="col-4">
              <h5>View Our Testnet Explorder</h5>
              <p>A quick and easy way to confirm transations, interact with smart contracts, and montior our network.</p>
              <a className="button is-link" href="https://testnet-explorer.gochain.io/" target="_blank">View Now</a>
            </div>
            <div className="col-4">
              <h5>Build Faster With Our CLI tool</h5>
              <p>Our Command-line tool makes building and deploying a breeze. View our full tutorial below.</p>
              <a className="button is-link" href="https://github.com/gochain-io/web3" target="_blank">Try it Now</a>
            </div>
            <div className="col-4">
              <h5>GoChain Developer Documentation</h5>
              <p>Learn everything about how to start building to how our network opperates -- all in one simple place.</p>
              <a className="button is-link" href="https://github.com/gochain-io/docs" target="_blank">View Now</a>
            </div>
          </div>
        </div>
        <div className="container">
          <FaucetInfo />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js